import Details from '@/components/Products/Details';
import ProductLayout from '@/components/Products/ProductLayout';

const ProductDetails = () => {
  return (
    <ProductLayout>
      <Details />
    </ProductLayout>
  );
};

export default ProductDetails;
